export const setCompanyId = (companyId) => ({
    type: 'SET_COMPANY_ID',
    payload: companyId,
});
export const setLenguaje = (lenguaje) => ({
    type: 'SET_LENGUAJE',
    payload: lenguaje,
});
